import volumeBtn from "@assets/imgs/btns/volume-btn.png";
import volumeMutedBtn from "@assets/imgs/btns/volume-muted-btn.png";
import { AudioManager } from "@/phaser/core/audio/AudioManager";
import { BaseButton } from "@phaser/ui/btns/BaseButton";

export class VolumeBtn extends BaseButton {
  private bg: Phaser.GameObjects.Image;
  private muted: boolean;

  static preload(scene: Phaser.Scene) {
    scene.load.image("volume-btn", volumeBtn);
    scene.load.image("volume-muted-btn", volumeMutedBtn);
  }

  constructor(scene: Phaser.Scene, x: number, y: number, onClick: () => void) {
    super(scene, x, y, {
      onClick: async () => {
        this.muted = await AudioManager.toggleMute();
        this.resetButton();

        onClick?.();
      },
      sfx: () => AudioManager.playSfx("sfx-button"),
      onPress: () => this.setPressedStyle(),
      onRelease: () => this.resetButton(),
    });

    this.muted = AudioManager.isMuted();

    this.bg = scene.add
      .image(0, 0, this.muted ? "volume-muted-btn" : "volume-btn")
      .setOrigin(0.5);

    this.add(this.bg);

    this.enableButton(this.bg.width, this.bg.height);

    scene.add.existing(this);
  }

  private setPressedStyle() {
    if (this.muted) {
      this.setScale(0.9);
    } else {
      this.setScale(0.9);
    }
  }

  private resetButton() {
    this.setScale(1);

    this.bg.setTexture(this.muted ? "volume-muted-btn" : "volume-btn");
  }
}
